import React, { useState, useEffect } from "react";
import OrngMsg from "../assets/orngMsg.svg";
import bookIcone from "../assets/bookUserr2.png";
import crossNotti from "../assets/crossCnc-icon.svg";
import {
  server_post_data,
  get_all_unread_notification,
  update_notification_read_status,
} from "../ServiceConnection/serviceconnection.js";
import {
  inputdateformateChange,
  formatTimeintotwodigit,
  handleLinkClick,
  handleError,
  handleSuccess,
} from "../CommonJquery/CommonJquery";
import { Modal, Button } from "react-bootstrap";
import DoneGreen from "../assets/doneGreen.svg";
import { firebaseService } from "../FirebaseConnection/FirebaseService"; // Adjust the path as needed
import { getFirestore, doc, updateDoc, onSnapshot } from "firebase/firestore";
let time_one = true;
const NotificationBar = ({ isOpen, toggleNotification }) => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [notifications, setnotifications] = useState([]);
  const [SelectedData, setSelectedData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  useEffect(() => {
    if (time_one) {
      time_one = false;
      master_data_get("", "", "1", "0");
    }
  }, []);

  const hideNotification = (click_type) => {
    let primary_id = click_type;

    master_data_action_update_notification(primary_id, click_type);
  };

  // Get a Firestore instance
  const db = getFirestore();
  // Reference to the Category you want to listen to
  const collectionRef = doc(db, "notification_start", "always_update_data");
  console.log("ddd call data");
  onSnapshot(collectionRef, async (docSnapshot) => {
    if (docSnapshot.exists()) {
      if (docSnapshot.data().data_update === 1) {
        if (time_one) {
          time_one = false;
          const updatedData = {
            data_update: 0,
          };
          await updateDoc(collectionRef, updatedData);

          master_data_get("", "", "1", "0");
        }
      }
    }
  });

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(get_all_unread_notification, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setnotifications(Response.data.message.data_reservation_data);
        }
        time_one = true;
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        time_one = true;
        setshowLoaderAdmin(false);
      });
  };

  const master_data_action_update_notification = async (
    call_id,
    click_type,
  ) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();

    fd.append("call_id", call_id);
    fd.append("click_type", click_type);
    await server_post_data(update_notification_read_status, fd)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (time_one) {
            time_one = false;
            master_data_get("", "", "1", "0");
          }
        }
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  return (
    <>
      <div className={`notification-sidebar ${isOpen ? "open" : ""}`}>
        <div className="notificationBar">
          <div className="noti_Text">
            <label>NOTIFICATION</label>
            <div className="closeNoti">
              <button
                onClick={toggleNotification}
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                htmlFor="top"
                title={`Close Notification `}
              >
                <img src={crossNotti} alt="img"></img>
              </button>
            </div>
          </div>
          {/* <div className="All_request_Cont">
            <div className="AlL_section onSelectedNoti">
              <button>All</button>
            </div>
            <div className="Request_section">
              <button>Request (0)</button>
            </div>
          </div> */}
          <div className="noticontent">
            {notifications.length > 0 ? (
              notifications.map((notification, index) => (
                <div className="Notification_hall" key={index}>
                  <div className="grppp">
                    <div className="imgGrP">
                      <button
                        onClick={(e) =>
                          hideNotification(notification.primary_id)
                        }
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        htmlFor="top"
                        title={`Clear Notification `}
                      >
                        <img src={crossNotti} alt="img"></img>
                      </button>
                    </div>

                    <div className="reservastion_rq">
                      <img src={bookIcone} alt="img"></img>
                      <label>Reservation Request</label>
                    </div>
                    <div
                      className="dates_aRriVe"
                      style={{ lineHeight: "normal" }}
                    >
                      <label className="p-0" style={{ lineHeight: "normal" }}>
                        {inputdateformateChange(notification.book_date)} at{" "}
                        {formatTimeintotwodigit(notification.book_time)} for{" "}
                        {notification.no_of_guest}P
                      </label>
                    </div>
                    <div
                      className="Name_aRriVe"
                      style={{ lineHeight: "normal" }}
                    >
                      <span className="p-0" style={{ lineHeight: "normal" }}>
                        {notification.guest_name}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no_noti">
                <p>
                  Your Notifications <span>Will Appear Here</span>!
                </p>
              </div>
            )}
          </div>
          {notifications.length > 0 && (
            <div className="Notification_hall  notiConTenr">
              <div className="clearNoti_btn">
                <button
                  className="clearNotiBtn"
                  onClick={(e) => hideNotification(0)}
                >
                  Clear All Notification
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationBar;
